import { AppState } from 'store/reducer';

export const partnersList = ({ partnersList: { data, loading, total, pagination } }: AppState) => ({
  data,
  total,
  loading,
  pagination,
});
